<template>
  <div class="track main-top-border main-bg">
    <div class="main-wrap">
      <nav-crumb class="crumb-pt"></nav-crumb>
      <div class="fl track-l">
        <div class="top track-part">
          <h3 class="track-title">{{dynamicInfo.title}}</h3>
          <div class="track-opt">
            <span class="fl track-time">{{dynamicInfo.createTime}}</span>
            <ul class="fr track-opt-btn">
              <li><i class="el-icon-chat-dot-square"></i>{{dynamicInfo.countReply}}</li>
              <!--<li><i class="el-icon-chat-dot-square"></i>转发</li>-->
            </ul>
          </div>
          <div class="track-desc">
            {{dynamicInfo.content}}
          </div>
          <video
                  v-if="dynamicInfo.video"
                  class="video-main"
                  :src="$common.videoPath(dynamicInfo.video)"
                  controls
          >

          </video>
          <div class="track-photo" v-if="!dynamicInfo.video&&dynamicInfo.photo">
            <el-image :src="$common.imgPath(photo)" v-for="photo in dynamicInfo.photo.split(',')" :key="photo" :alt="photo" class="img" lazy></el-image>
          </div>
          <div class="like" @click="fabulous()">
            <button class="btn-like"><i class="el-icon-thumb"></i><br>{{dynamicInfo.goodNum}}</button>
            <br>点赞
          </div>
        </div>
        <div class="mid comment track-part mt10">
          <p class="comment-title">评论</p>
          <ul v-if="replyList.length>0">
            <li class="comment-list" v-for="(item,index) in replyList" :key="index">
              <div class="comment-first">
                <el-image class="list-cell img" :src="$common.imgPath(item.oneLevel.userInfo.headImg)" :alt="item.oneLevel.userInfo.nickName" lazy></el-image>
                <div class="list-cell comment-info">
                  <p><span class="comment-name">{{item.oneLevel.userInfo.nickName}}</span>
                    <span class="comment-time">发表于{{item.oneLevel.createTime}}</span>
                  </p>
                  <p class="comment-cont">{{item.oneLevel.content}}</p>
                </div>
                <div class="list-cell reply" v-if="item.oneLevel.userId!==userId"><button type="button" class="btn-reply" @click="currentAddDynamic(item.oneLevel.userInfo.nickName,item.oneLevel.id,item.oneLevel.id)">回复</button></div>
              </div>
              <ul class="sub-comment" v-if="item.twoLevel.length!==0">
                <li
                    class="sub-comment-list"
                    v-for="(subItem,subIndex) in item.twoLevel"
                    :key="subIndex"
                >
                  <div class="sub-item sub-left">
                    <el-image class="sub-img" :src="$common.imgPath(subItem.userInfo.headImg)" :alt="subItem.userInfo.nickName" lazy></el-image>
                    <span class="sub-name">{{subItem.userInfo.nickName}}</span>
                    <span class="sub-cont">{{subItem.content}}</span>
                  </div>
                  <div class="sub-item sub-right">
                    <span class="sub-time">{{subItem.createTime}}</span>
                    <span class="sub-reply" v-if="item.oneLevel.userId!==userId&&subItem.userId!==userId"><button type="button" class="btn-sub-reply" @click="currentAddDynamic(subItem.userInfo.nickName,subItem.oneId,subItem.id)">回复</button></span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="bot track-part mt10">
          <input ref="replyInput" type="text" :placeholder="replyNikeName==''?'评论...':'回复：'+replyNikeName" class="inp-comment" v-model="replyValue">
          <button type="button" class="btn-comment" @click="addDynamic()">发表</button>
        </div>
      </div>
      <div class="fr track-r">
        <div class="people-info">
          <el-image class="img" :src="$common.imgPath(dynamicInfo.user.headImg)" :alt="dynamicInfo.user.nickName" lazy></el-image>
          <p class="name">{{dynamicInfo.user.nickName}}</p>
          <div class="btns" v-show="dynamicInfo.user.shopId">
            <button type="button" class="btn-base btn-follow" @click="setShopFollow(dynamicInfo.user.shopId)" v-text="isCollect?'取消关注':'关注'"></button>
            <button type="button" class="btn-base btn-detail" @click="$router.push({'path':`/celebrity/detail/${dynamicInfo.user.shopId}`})">查看资料</button>
          </div>
        </div>
        <!--<div class="sm-qr mt10">-->
          <!--<p class="qr-tit">扫二维码下载名人名兰app</p>-->
          <!--<div class="app-info">-->
            <!--<div class="item item1">-->
              <!--<p>下载app</p>-->
              <!--<p>看高清直播、视频！</p>-->
            <!--</div>-->
            <!--<div class="item qr-app"></div>-->
          <!--</div>-->

        <!--</div>-->
      </div>
    </div>
  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import {getShopInfoForUser,setShopFollow} from '../../api/shop'
    import {getReplyList,getDynamicInfo,addDynamic,fabulous} from '../../api/dynamic'
  export default {
        data(){
            return {
                current:1,
                size:15,
                shopId:'',//名人店铺ID
                isCollect:false,//关注名人
                replyValue:'',//回复内容
                replyNikeName:'',
                oneId:0,//一级回复的ID
                replyDynamicId:0,//動態id,回复chId==0时填上0,否则填上回复的id
                dynamicInfo:{
                    user:{
                        headImg:''
                    }
                },//动态文章详情
                replyList:[]
            }
        },
      components:{
          navCrumb
      },
      computed:{
          dynamicId(){
              return this.$route.params.id||0;
          },
          userId(){
              const userInfo = JSON.parse(localStorage.getItem('user'))||null;//登录用户信息
              let id=0;
              userInfo?id=userInfo.userId:id=0;
              return id;
          }
      },
      created () {
          this.getReplyList();
          this.getDynamicInfo();
      },
      methods:{
          clearData(){
              this.replyValue='';//回复内容
              this.replyNikeName='';
              this.oneId=0;//一级回复的ID
              this.replyDynamicId=0;//動態id,回复chId==0时填上0,否则填上回复的id
          },
          getReplyList(){
              getReplyList({
                  dynamicId:this.dynamicId,
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.replyList=res.data;
              }).catch(err=>{
                  console.log('celebrityInfo',err);
              })
          },
          getDynamicInfo(){
              getDynamicInfo({
                  dynamicId:this.dynamicId,
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.dynamicInfo=res.data;
                  this.shopId=res.data.user.shopId;
                  this.getShopInfoForUser();
              }).catch(err=>{
                  console.log('celebrityInfo',err);
              })
          },
          addDynamic(){
              if(this.replyValue == ""){
                  this.$message({
                      message: '评论内容不能为空！',
                      type: 'error'
                  });return false;
              }
              addDynamic({
                  userId:this.userId,
                  dynamicId:this.dynamicId,
                  content:this.replyValue,
                  oneId:this.oneId,
                  replyDynamicId:this.replyDynamicId
              }).then(res=>{
                  this.$message({
                      message: '评论成功！',
                      type: 'success'
                  });
                  this.clearData();
                  this.getReplyList();
                  console.log('celebrityInfo',res);
              }).catch(err=>{
                  console.log('celebrityInfo',err);
              })
          },
          currentAddDynamic(nikeName,oneId,replyDynamicId){
              this.replyNikeName=nikeName;
              this.oneId=oneId;
              this.replyDynamicId=replyDynamicId;
              this.$nextTick(()=>{   //评论
                  this.$refs.replyInput.focus();
              })
          },
          fabulous(){
              fabulous({
                  userId:this.userId,
                  dynamicId:this.dynamicId,
              }).then(res=>{
                  this.getDynamicInfo();
                  console.log('celebrityInfo',res);
              }).catch(err=>{
                  console.log('celebrityInfo',err);
              })
          },
          getShopInfoForUser(){
              getShopInfoForUser(this.shopId).then(res=>{
                  if(res.data){
                      this.isCollect=res.data.isCollect;
                  }
              }).catch(err=>{
                  console.log(err)
              })
          },
          //操作关注/取消 店铺
          setShopFollow(shopId){
              if(this.userId){
                  setShopFollow({
                      shopId
                  }).then(res=>{
                      this.isCollect=res.data;
                  }).catch(err=>{
                      console.log(err)
                  })
              }else {
                  this.$message({
                      message: '请先登录！',
                      type: 'error'
                  });
                  this.$store.commit('changeLoginShow',true);
              }

          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .track{
    .crumb-pt{
      padding:15px 0 24px 0;
    }
    overflow: auto;
    .track-part{padding:30px;background-color:#ffffff;}
    .track-l{
      width:880px;
      .top{

        .track-title{color:#333333;font-size:26px}
        .track-opt{
          overflow: hidden;color:#999999;font-size:14px;
          padding:17px 0 27px;
          .track-opt-btn{
            li{
              float: left;
              padding-left:30px;
              i{font-size:20px;
                vertical-align: middle;padding-right:10px;}
            }
          }
        }
        .track-desc{
          border-top:1px solid rgba(240,240,240,1);
          padding:30px 0 10px;
        }
        .video-main{
          width:100%;
        }
        .track-photo{
          padding:10px 34px;
          .img{width:100%;}
          .img+.img{
            margin-top:10px;
          }
        }
        .like{
          text-align: center;padding:10px 0;font-size:12px;
          .btn-like{
            width:80px;
            height:80px;
            font-size:12px;
            background-color:#F7F7F7;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            i{font-size:30px;}
            margin-bottom:10px;
          }
        }
      }
      .mid{
        .comment-title{
          font-size:16px;
          color:#333333;
          font-weight:600;
          border-bottom:1px solid #F0F0F0;
          padding-bottom:10px;
          padding-left:20px;
        }
        .comment-list{
          padding-bottom:20px;
          &+.comment-list{border-top:1px solid rgba(240,240,240,1);}
          .comment-first{
            width:100%;
            padding:20px 0;
            overflow: hidden;
            .list-cell{
              float: left;}
            .img{
              width:50px;
              height:50px;
              background-color:$main-color;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
              border-radius: 50%;
            }
            .comment-info{
              padding-left:20px;
              line-height:26.22px;
              width:500px;
              .comment-name{color:$main-color;font-size:20px;}
              .comment-time{color:#999999;font-size:14px;padding-left:15px;}
              .comment-cont{color:#333333;font-size:16px;}
            }
            .reply{
              float: right;
              text-align: center;}

          }
          .sub-comment{
            background-color:#F0F0F0;
            padding:20px 20px 20px 73px;
            .sub-comment-list{
              &+.sub-comment-list{
                margin-top:10px;
              }
              overflow: hidden;
              width:100%;
              /*.sub-item{
                display: table-cell;
                vertical-align: middle;}*/
              .sub-left{
                float: left;
                font-size:16px;color:#333333;
                .sub-img{
                  display: inline-block;
                  vertical-align: middle;
                  width:44px;
                  height:44px;
                  -webkit-border-radius: 50%;
                  -moz-border-radius: 50%;
                  border-radius: 50%;background-color:$main-color;
                }
                .sub-name{color:$main-color;padding-left:11px;}
                .sub-cont{
                  display: inline-block;
                  width:400px;
                  padding-left:20px;
                  vertical-align: text-top;
                }
              }
              .sub-right{
                float: right;
                text-align: right;
                color:#333;
                .sub-time{font-size:14px;}
                .sub-reply{font-size:16px;padding-left:20px;}
              }
            }

          }

        }
      }
      .bot{
        .inp-comment{
          width:801px;
          height:68px;
          border:2px solid rgba(228,224,224,1);
          padding:0px 10px;
        }
        .btn-comment{
          width:112px;
          height:47px;
          background:rgba(21,178,73,1);
          color:#fff;
          font-size:20px;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          border-radius: 3px;
          margin-top:20px;
        }
      }

    }
    .track-r{
      .people-info{
        text-align: center;
        background-color:#fff;padding:30px 55px 45px;width:300px;
        .img{width:100px;height:100px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;}
        .name{font-size:24px;color:#5876A3;padding-top:20px;
          font-weight:600;}
        .btns{
          padding-top:22px;
          .btn-base{border:1px solid #CCCCCC;
            font-size:14px;
            color:#333;
            width:83px;
            height:29px;
            -webkit-border-radius: 3px;
            -moz-border-radius: 3px;
            border-radius: 3px;}
          .btn-follow{border:1px solid $main-color;color:$main-color;margin-right:20px;}
        }
      }
      .sm-qr{
        font-size:14px;
        padding:25px 22px 30px 30px;
        background-color:#fff;

        .qr-tit{font-size:18px;
          font-weight:600;padding-bottom:19px;}
        .app-info{
          display: table;width:100%;
          .item{display: table-cell;
            vertical-align: middle;}
          .item1 p:last-child{padding-top:17px;}
        }
        .qr-app{width:100px;
          height:100px;
          background-color:$main-color;}
      }
    }
  }
</style>
